import {UserApiConnector} from './user_api_connector';

import {EVENTS} from './events';

export class AdminApiConnector extends UserApiConnector {

	_stop_conversation_chain = false;
	conversation_chain = 0;

	is_conversation_chain_stopped(force) {
		return (force || this._stop_conversation_chain);
	}

	stop_conversation_chain() {
		this.stopper && this.stopper();
		this._stop_conversation_chain = true;
	}

	start_conversation_chain() {
		this._stop_conversation_chain = false
	}

    start_conversation(params, do_not_chain) {
		// Stop the previous chain if new chain request
		this.do_not_chain !== true && this.stopper && this.stopper();
        var interept = false;

    	const internal_loop = () => {
    		params = params || {};
        	params.action = this.ACTION_GET_CONVERSATIONS;

        	jQuery.post(this.options.endpoint, params, (data) => {
    			if (this.is_conversation_chain_stopped(do_not_chain) || interept) {
    				clearTimeout(this.conversation_chain);
    			} else {
					this.conversation_chain = setTimeout(() => {
        				internal_loop();
    				}, 5000);
    			}

    			if (interept) {
    				return;
    			}

            	if (data.data.length === 0) {
            		interept = true;
                	this.chat.trigger(EVENTS.WSCHAT_ON_NO_CONVERSATIONS);
                	return;
            	}

            	this.chat.trigger(EVENTS.WSCHAT_ON_FETCH_CONVERSATIONS, data.data);
        	});
        }

		internal_loop();

		// Update the stoper only if the request is not chain
		if (do_not_chain !== true) {
			this.stopper = function () {
				interept = true;
			}
		}
    }

    get_conversations(params) {
    	return this.start_conversation(params, true);
    }

    join_conversation(id, agent_id) {
        this.reset_filters();

        jQuery.post(this.options.endpoint, {
            action: this.ACTION_JOIN_CONVERSATION,
            conversation_id: id,
            agent_id: agent_id
        }, (data) => {
            this.chat.set_conversation(data.data);
        });
    }

    delete_conversation(id) {
        this.reset_filters();
        console.log('deleting conversation ' + id);

        jQuery.post(this.options.endpoint, {
            action: this.ACTION_DELETE_CONVERSATION,
            conversation_id: id,
        }, () => {
            this.chat.trigger(EVENTS.WSCHAT_ON_DELETE_CONVERSATIONS, id);
        });
    }
}

AdminApiConnector.prototype.ACTION_SEND_MESSAGE = 'wschat_admin_send_message';
AdminApiConnector.prototype.ACTION_GET_MESSAGE = 'wschat_admin_get_messages';
AdminApiConnector.prototype.ACTION_READ_ALL = 'wschat_admin_read_all';
AdminApiConnector.prototype.ACTION_GET_CONVERSATIONS = 'wschat_admin_get_conversations';
AdminApiConnector.prototype.ACTION_JOIN_CONVERSATION = 'wschat_admin_join_conversation';
AdminApiConnector.prototype.ACTION_DELETE_CONVERSATION = 'wschat_admin_delete_conversation';
